<tm-map-spinner [coordinates$]="featureInfoCoordinates$"
                        [loading$]="loadingFeatureInfo$"></tm-map-spinner>
<tm-feature-info-dialog></tm-feature-info-dialog>
